import React from "react";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import NextPlanOutlinedIcon from "@mui/icons-material/NextPlanOutlined";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarRateIcon from "@mui/icons-material/StarRate";
import CelebrationIcon from "@mui/icons-material/Celebration";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import { Tooltip } from "@mui/material";

const DevelopmentNeedStatusIcon = ({ status, hideTooltip = false }) => {
    let icon = <RadioButtonUncheckedIcon color={"disabled"} />;
    if (!status) {
        return icon;
    }

    const words = status.split("_");
    words[0] = words[0][0].toUpperCase() + words[0].substring(1);
    const title = words.join(" ");

    switch (status) {
        case "suggested":
            icon = <AutoGraphIcon color={"info"} />;
            break;

        case "agreed":
            icon = <AutoGraphIcon color={"success"} />;
            break;

        case "deferred":
            icon = <AutoGraphIcon color={"warning"} />;
            break;

        case "agreed_deferred":
            icon = <NextPlanOutlinedIcon color={"success"} />;
            break;

        case "incomplete":
            icon = <RadioButtonUncheckedIcon color={"disabled"} />;
            break;

        case "not_achieved":
            icon = <ErrorOutlineOutlinedIcon color={"error"} />;
            break;

        case "cancelled":
            icon = <AutoGraphIcon color={"disabled"} />;
            break;

        case "achieved":
            icon = <StarRateIcon color={"success"} />;
            break;

        case "partial_achieved":
            icon = <StarHalfIcon color={"success"} />;
            break;

        case "exceeded":
            icon = <CelebrationIcon color={"success"} />;
            break;

        case "completed":
            icon = <CheckCircleOutlineOutlinedIcon color={"success"} />;
            break;

        default:
            break;
    }

    if (hideTooltip) {
        return icon;
    }

    return (
        <Tooltip title={title} placement="top" arrow>
            {icon}
        </Tooltip>
    );
};

export default DevelopmentNeedStatusIcon;
